import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'telio-drag-drop',
  templateUrl: './drag-drop.component.html',
  styleUrls: ['./drag-drop.component.scss']
})
export class DragDropComponent implements OnInit, OnDestroy {

  @Input() predecessor = [];
  @Input() successor = [];
  @Input() predecessorLabel = 'rbac.todo';
  @Input() successorLabel = 'rbac.done';

  @Output() dragDropDataChange = new EventEmitter<{}>();

  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.dragDropDataChange.emit({ predecessor: this.predecessor, successor: this.successor });
  }

  ngOnDestroy(): void { }
}
